import { render, staticRenderFns } from "./BaseTruncatedField.vue?vue&type=template&id=52adb464&scoped=true&"
import script from "./BaseTruncatedField.vue?vue&type=script&lang=js&"
export * from "./BaseTruncatedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adb464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
